<div class="flooring-and-walling">
  <div class="flooring-and-walling-inner">
    <a class="flooring inner-content" routerLink="/flooring">
      <img class="content-img" [src]="s3BucketUrl + '/ASSETS/HOME/DISCOVER_FLOORING_WALLING/flooring.webp'"
           appHandleImageError alt="Flooring" loading="lazy" width="907" height="898" appSetImageDimensions>
      <div class="overlay">
        <p class="sub-title">Discover</p>
        <h3 class="title">FLOORING</h3>
      </div>
    </a>
    <a class="walling inner-content" routerLink="/walling">
      <img class="content-img" [src]="s3BucketUrl + '/ASSETS/HOME/DISCOVER_FLOORING_WALLING/walling.webp'" alt="Walling"
           appHandleImageError loading="lazy" width="907" height="898" appSetImageDimensions>
      <div class="overlay">
        <p class="sub-title">Discover</p>
        <h3 class="title">WALLING</h3>
      </div>
    </a>
  </div>
</div>
